// import './expander-new.js';
// import './menu-button-func.js';
// import './menu-button.js';
// import './expander-new.js';
import Expander from './expander.js';
// import './menu-focus.js';
// import './color-scheme.js';
// import './share-popups.js';
import './flickity.js';

// init menu button
let menuButton = document.querySelector('.site-nav__toggle');
if ( menuButton ) new Expander( menuButton );
